<template>
  <div>
    <b-card no-body >
      <b-card-body>
        <b-row>
          <b-col lg="2">
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  class="mr-1"
                  @click="traerParametros"
              >
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
              </b-button>
              <!--
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  class="mr-1"
              >
                <font-awesome-icon icon="fa-solid fa-plus"/>
              </b-button>
              <b-button
                  variant="gradient-primary"
                  size="sm"
              >
                <span v-if="loading2"> Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                <span v-else>
              <font-awesome-icon icon="fa-solid fa-file-excel"/>
            </span>


              </b-button>
              -->
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-table
          hover
          responsive
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon
                v-if="$can('update', 'Pr Man Parametros')"
                :id="`btn_${data.item.id}_editar`"
                icon="EditIcon"
                size="16"
                class="mr-1"
                @click="abrirModal(data.item)"
            />
            <b-tooltip
                title="Editar registro"
                :target="`btn_${data.item.id}_editar`"
            />
          </div>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>

    <b-modal
        id="modal-editar"
        v-model="modalEditar"
        no-close-on-esc
        no-close-on-backdrop
        cancel-variant="secondary"
        ok-title="Editar"
        cancel-title="Cancelar"
        :cancel-disabled="loadingEditar"
        :ok-disabled="loadingEditar||!hora"
        centered
        title="Editar Parámetro"
        @ok="editarRegistro"
    >
      <div v-if="loadingEditar"  align="center">
        <p>Editando dato ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <b-form v-else>
        <b-form-group
            label="Día de la semana"
            label-for="dia"
        >
          <v-select
              id="dia"
              v-model="dia"
              :options="dias"
              placeholder="Seleccionar día..."
              :clearable="false"
          />
        </b-form-group>
        <b-form-group
            label="Hora"
            label-for="hora"
        >
          <b-form-timepicker
              v-model="hora"
              show-seconds
              locale="en"
          />
        </b-form-group>
        <b-form-group
            label="Estado"
            label-for="estado"
        >
          <v-select
              id="estado"
              v-model="estado_aprobar"
              :options="estados"
              :reduce="estados => estados.value"
              label="text"
              key="value"
              placeholder="Seleccionar estado..."
              :clearable="false"
          />
        </b-form-group>

      </b-form>
    </b-modal>
  </div>
</template>

<script>

import {
  BBadge,
  BButton,
  BCard,
  BCardBody, BCol, BForm,
  BFormGroup, BFormInput,
  BFormSelect, BFormTimepicker, BModal,
  BPagination, BRow,
  BSpinner,
  BTable,
  BTooltip, VBModal,
} from 'bootstrap-vue'
import axiosIns from '../../../libs/axios'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BTooltip,
    BCol,
    BRow,
    BForm,
    BFormInput,
    BFormTimepicker,
    BModal,
    VBModal,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  data: () => ({
    loading: false,
    loadingEditar: false,
    items: [],
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: false,
    sortDirection: 'asc',
    filter: null,
    filterOn: [],
    fields: [
      {
        key: 'acciones',
        label: '# ',
      },
      {
        key: 'cod',
        label: 'código',
        sortable: true,
      },
      {
        key: 'nombre',
        label: 'nombre',
        sortable: true,
      },
      {
        key: 'descripcion',
        label: 'descripción',
        sortable: true,
      },
      {
        key: 'valor',
        label: 'valor',
        sortable: true,
      },
      {
        key: 'valor2',
        label: 'valor 2',
        sortable: true,
      },
      {
        key: 'estado',
        label: 'estado',
        sortable: true,
      },
    ],
    status: [
      {
        0: 'Activo',
        1: 'Inactivo',
      },
      {
        0: 'light-success',
        1: 'light-danger',
      }
    ],

    estados: [
      {value: '0', text: "Activo"},
      {value: '1', text: "Inactivo"}
    ],

    estado_aprobar: null,

    modalEditar: false,
    dias: ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO', 'DOMINGO'],
    dia: null,
    hora: null,

    codigo: null,
    id_user_e: null,
    id_registro: null,
  }),
  computed: {},
  mounted() {
    this.traerParametros();
  },
  methods: {
    traerParametros(){
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/pagricolas/parametros/'
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data.filter(
                  invoice =>
                      invoice.con_usuario === 1
              );
              yo.totalRows = yo.items.length
            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          })

    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    abrirModal(datos){
      const yo = this
      yo.modalEditar = true
      yo.dia = datos['valor']
      yo.hora = datos['valor2']
      yo.codigo = datos['cod']
      yo.id_user_e = datos['con_usuario']
      yo.id_registro = datos['id']
      yo.estado_aprobar = datos['estado']
    },

    editarRegistro(){
      const yo = this
      yo.loadingEditar = true

      const data = JSON.stringify({
        "cod": yo.codigo,
        "valor": yo.dia,
        "valor2": yo.hora,
        "con_usuario": yo.id_user_e,
        "estado": yo.estado_aprobar
      });

      const config = {
        method: 'put',
        url: '/pagricolas/parametros/editar/'+yo.id_registro,
        headers: {
          'Content-Type': 'application/json',
        },
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.traerParametros()
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó de manera correcta", 'success', 5000)
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
          })
          .finally(function (){
            yo.loadingEditar = false
          })

    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },
  },
}
</script>

<style lang="scss">
</style>
